<template>
    <div>
        <list-item>
            <template slot="icon">
                <i class="text-blue far fa-calendar-alt"></i>
            </template>
            <template slot="title">Date</template>
            <template slot="sub-title">{{formatDate(expense.date, 'D MMM YYYY')}}</template>
        </list-item>

        <list-item>
            <template slot="icon">
                <i class="text-blue far fa-clock"></i>
            </template>
            <template slot="title">
                Number of Hours
                {{expense.type_name === 'Night Time Allowance' ? '(22-06)' : ''}}
            </template>
            <template slot="sub-title">
                {{expense.amount}}
                Hrs
            </template>
        </list-item>
    </div>
</template>

<script>
import InteractsWithDates from '@/mixins/InteractsWithDates';

export default {
    mixins: [InteractsWithDates],
    props: ['expense'],
}
</script>
